import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import {
  DOCUMENT_TRAINING_ROUTE,
  DOCUMENT_TRAINING_DETAIL_ROUTE,
} from "./DocumentTraining.constants";

const DocumentTrainingList = Loadable(
  lazy(() => import("./DocumentTrainingList"))
);

const DocumentTrainingDetail = Loadable(
  lazy(() => import("./DocumentTrainingDetail"))
);

export const genAiKnowledgeBaseRoutes = [
  {
    path: `${DOCUMENT_TRAINING_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <DocumentTrainingList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${DOCUMENT_TRAINING_DETAIL_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[]} allowFullAccess>
        <DocumentTrainingDetail />
      </AuthorizedRoute>
    ),
  },
];
